export default {
  VIDEOS: "videos",
  ACTIVITIES: "activities",
  TAGS: "tags",
};
